module.exports = __webpack_public_path__ + "img/ctc-other.47fc9620.png";